import {
  AfterViewChecked, Directive, EmbeddedViewRef, Input, OnChanges, Renderer2, SimpleChanges, TemplateRef, ViewContainerRef
} from '@angular/core';

// Keep the last rendered day on screen while its replacement loads. Detaching
// change detection also hides intermediate model resets inside grids and forms.
@Directive({ selector: '[appRetainDuringDateChange]' })
export class RetainDuringDateChangeDirective implements OnChanges, AfterViewChecked {
  @Input() appRetainDuringDateChange = false;
  @Input() appRetainDuringDateChangeBusy = false;
  @Input() appRetainDuringDateChangeKey: any;

  private view: EmbeddedViewRef<any>;
  private ready = false;
  private retaining = false;
  private buttonStates = new Map<HTMLButtonElement, boolean>();

  constructor(template: TemplateRef<any>, container: ViewContainerRef, private renderer: Renderer2) {
    this.view = container.createEmbeddedView(template);
  }

  ngAfterViewChecked() {
    // The toolbar can already be visible while page data is still loading.
    // Preserve that rendered view without waiting for every loader to settle.
    if (!this.appRetainDuringDateChange && !this.retaining) {
      this.ready = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const busy = this.appRetainDuringDateChange || this.appRetainDuringDateChangeBusy;
    // A different page implementation must render before its loader can run
    // (for example, crossing the jacking activity V1/V2 boundary).
    const keyChange = changes.appRetainDuringDateChangeKey;
    if (keyChange && !keyChange.firstChange) {
      this.ready = false;
      this.retaining = false;
      this.setBusy(false);
      this.view.reattach();
    }
    if (this.ready && this.appRetainDuringDateChange && !this.retaining) {
      this.retaining = true;
      this.view.detach();
      this.setBusy(true);
    }

    if (!busy) {
      if (this.retaining) {
        this.retaining = false;
        this.setBusy(false);
        this.view.reattach();
      }
    }
  }

  private setBusy(busy: boolean) {
    // Bindings are frozen with the retained view, so explicitly apply native
    // disabled states to its buttons and restore them before bindings resume.
    if (!busy) {
      this.buttonStates.forEach((disabled, button) => this.renderer.setProperty(button, 'disabled', disabled));
      this.buttonStates.clear();
    }
    this.view.rootNodes.filter(node => node.nodeType === 1).forEach(node => {
      if (busy) {
        const buttons = Array.from(node.querySelectorAll('button')) as HTMLButtonElement[];
        if (node.tagName === 'BUTTON') { buttons.push(node); }
        buttons.forEach(button => {
          this.buttonStates.set(button, button.disabled);
          this.renderer.setProperty(button, 'disabled', true);
        });
        this.renderer.setAttribute(node, 'inert', '');
        this.renderer.setAttribute(node, 'aria-busy', 'true');
        this.renderer.addClass(node, 'retained-day-content');
      } else {
        this.renderer.removeAttribute(node, 'inert');
        this.renderer.removeAttribute(node, 'aria-busy');
        this.renderer.removeClass(node, 'retained-day-content');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/directives/retain-during-date-change.directive.ts